export default [
  {
    path: "/driverInvitation",
    name: "driverInvitation",
    component: () =>
      import(
        /* webpackChunkName: "driverInvitation" */ "@/views/driverInvitation/index.vue"
      ),
    hidden: true,
  },
];
